export const documentTemplate = (state) => state?.entities?.documentTemplate;
